export const homeObjOne = {
    id:'about',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'Akylbek Muratbek uulu',
    headLine:'About me',
    description:` Creative Front-End Developer offering 1 year of experience providing highimpact web solutions for diverse industry organizations. Skilled in designing,
    developing, and testing multiple web-based applications incorporating a
    range of technologies. Aspiring to combine broad background with strong
    technical skills to excel as a Front-End Developer.`,
    imgStart:false,
    img:require('../../images/svg-8.svg'),
    alt:'Car',
    dark:false,
    primary:false,
    darkText:true
};


export const homeObjTwo = {
    id:'discover',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'Akylbek Muratbek uulu',
    headLine:`Experience`,
    description:`Upgraded code and design of existing websites with JavaScript.
    Designed REST calls using React to streamline user interface performance.
    Designing frontend within Javascript frameworks like React.js
    Designed dynamic and browser compatible pages using HTML5, CSS3,
    jQuery, and Javascript.
    Developed and maintained a website for the organization, including
    content and design.
    Assisted other developers with the design and implementation of web
    applications using HTML, XML, and CSS
    Participated actively in the creation of new HTML5 and CSS pages for the
    web.
    . `,
    imgStart:true,
    img:require('../../images/svg-2.svg'),
    alt:'Piggybank',
    dark:false,
    primary:false,
    darkText:true
};



